<template>
  <el-card>
    <div class="add-client-wrap">
      <div class="title">物料单列表</div>
    </div>
    <div class="filter-list-wrap">
      <span>状态筛选：</span>
      <el-select
        v-model="filterStatus"
        placeholder="请选择出货状态">
        <el-option label="全部" :value="-1"></el-option>
        <el-option label="待出货" :value="0"></el-option>
        <el-option label="已出货" :value="1"></el-option>
        <el-option label="已撤销" :value="2"></el-option>
      </el-select>
      <el-input
        style="width:200px;"
        placeholder="根据物料单号搜索"
        v-model="filterMoNumber"
        clearable>
      </el-input>
    </div>
    <div class="table-wrap">
      <el-table
        :data="listData"
        stripe>
        <el-table-column
          width="190px"
          prop="moNumber"
          label="物料单号">
        </el-table-column>
        <el-table-column
          label="物料类型">
          <template slot-scope="scope">
            <span v-if="scope.row.moType==1">订单</span>
            <span v-if="scope.row.moType==2">样品</span>
            <span v-if="scope.row.moType==3">外借</span>
            <span v-if="scope.row.moType==4">变更系统</span>
          </template>
        </el-table-column>
        <el-table-column
          label="状态">
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.moStatus==0">待出货</el-tag>
            <el-tag type="success" v-if="scope.row.moStatus==1">已出货</el-tag>
            <el-tag type="info" v-if="scope.row.moStatus==2">已撤销</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="materialInfo"
          label="物料信息">
        </el-table-column>
        <el-table-column
          prop="createdBy"
          label="提单人员">
        </el-table-column>
        <el-table-column
          label="出货截止时间">
          <template slot-scope="scope">
            {{scope.row.latestShipmentTime | time}}
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="200">
          <template slot-scope="scope">
            <el-button v-if="scope.row.moStatus==0" @click="beginShipment(scope.row)" type="text" size="small">出货</el-button>
            <el-button v-else type="text" size="small" disabled>出货</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="table-page-wrap">
      <el-pagination
        @current-change="currentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新增出货 -->
    <el-dialog
      :title="dialogTitle"
      :close-on-click-modal="false"
      :visible.sync="shipmentDialog"
      :before-close="closeDialog"
      width="400px">
      点击
      <a style="color: #409EFF;" href="http://imgs.creekspring.com/ignis-shipment-tempate.zip" target="_blank">[下载模板]</a>
      <el-upload
        class="upload-demo"
        ref="upload"
        drag
        :on-success="uploadSuccess"
        :on-error="uploadError"
        :data="shipmentData"
        :action="uploadUrl"
        :headers="headers"
        :auto-upload="false"
        :on-change="uploadPreview"
        :limit="1"
        multiple>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
      <div v-if="dialogTitle === '新增出货'" class="sub-system-wrap">
        <el-cascader
          style="margin-bottom:6px;"
          v-if="this.systemType==2"
          clearable
          filterable
          placeholder="请选择产品型号"
          expand-trigger="hover"
          :options="productModelOptions"
          @change="productModelIdhandleChange">
        </el-cascader>
        <el-input
          v-if="this.systemType==2"
          type="number"
          min="0"
          max="29"
          style="margin-bottom: 8px;"
          placeholder="配电柜支路数，不是配电柜可不填"
          v-model="shipmentData.branchNum">
        </el-input>
        <el-input
          v-if="this.systemType==2"
          type="number"
          min="0"
          max="6"
          style="margin-bottom: 8px;"
          placeholder="配电柜防盗主机数，不是配电柜可不填"
          v-model="shipmentData.mainTheftPreventionNum">
        </el-input>
      </div>
      <el-select style="margin-bottom:5px;" v-model="shipmentData.isOver" placeholder="请选择">
        <el-option label="未完结" :value="0"></el-option>
        <el-option label="已完结" :value="1"></el-option>
      </el-select>
      <el-input
        placeholder="请输入备注内容"
        v-model="shipmentData.remark"
        clearable>
      </el-input>
      <el-button style="margin-top: 8px;" size="small" type="success" @click="submitUpload">上传文件</el-button>
    </el-dialog>
    <!-- 出货结果反馈 -->
    <el-dialog
      title="出货错误反馈"
      width="700px"
      :close-on-click-modal="false"
      :visible.sync="importResultDialog">
      <importResult :taskImportResult="taskImportResult"></importResult>
    </el-dialog>
  </el-card>
</template>

<script>
import http from 'http';
import importResult from './child/importResult';

export default {
  name: 'materialList',
  components: {
    importResult
  },
  data () {
    return {
      filterStatus: 0,
      filterMoNumber: '',
      fileLength: 0,
      currentPage: 1,
      importResultDialog: false,
      taskImportResult: {},
      systemType: 0,
      pageSize: 10,
      tableData: [],
      shipmentDialog: false,
      dialogTitle: '新增出货',
      productModelOptions: [],
      shipmentData: {
        remark: '',
        moNumber: '',
        productId: 0,
        productModelId: 0,
        branchNum: 0,
        mainTheftPreventionNum: 0,
        isOver: 1
      }
    };
  },
  computed: {
    headers () {
      return {
        'Authorization': `Bearer ${this.$store.state.login.token}`
      };
    },
    uploadUrl () {
      return `/api/v1/device-sns/shipment-for-mo`;
    },
    listData () {
      let start = (this.currentPage - 1) * this.pageSize;
      let end = start + this.pageSize;
      if (this.filterStatus === -1) return this.tableData.filter(item => item.moNumber.indexOf(this.filterMoNumber) !== -1).slice(start, end);
      return this.tableData.filter(item => item.moStatus === this.filterStatus).filter(item => item.moNumber.indexOf(this.filterMoNumber) !== -1).slice(start, end);
    },
    total () {
      if (this.filterStatus === -1) return this.tableData.filter(item => item.moNumber.indexOf(this.filterMoNumber) !== -1).length;
      return this.tableData.filter(item => item.moStatus === this.filterStatus).filter(item => item.moNumber.indexOf(this.filterMoNumber) !== -1).length;
    }
  },
  methods: {
    currentChange (val) {
      this.currentPage = val;
    },
    // 获取款式列表
    async getProductModel () {
      let { data } = await http.get('/v1/product-model/list-product-and-model');
      this.productModelOptions = data.filter(item => {
        if (item.productModels !== undefined) {
          return item;
        }
      }).map(item => {
        return {
          value: item.productId,
          label: (item.tag ? `【${item.tag}】` : '') + item.productName,
          children: item.productModels.map(subItem => {
            return {
              value: subItem.id,
              label: subItem.modelName
            };
          })
        };
      });
    },
    // 获取物料单列表
    async getMaterialList () {
      let { data } = await http.get(`/v1/mo-infos/shipment`);
      this.tableData = data;
    },
    beginShipment (item) {
      this.shipmentDialog = true;
      this.dialogTitle = '新增出货';
      this.shipmentData.moNumber = item.moNumber;
      this.systemType = item.systemType;
    },
    uploadSuccess (response, file, fileList) {
      this.$notify({
        title: '成功',
        message: '操作成功',
        type: 'success'
      });
      this.getMaterialList();
      this.resetFormData();
      this.shipmentDialog = false;
      if (response.detail !== undefined) {
        this.importResultDialog = true;
        this.importResult = response.detail;
      }
    },
    closeDialog (done) {
      this.resetFormData();
      done();
    },
    uploadPreview (file, fileList) {
      this.fileLength = fileList.length;
    },
    uploadError (response) {
      try {
        let result = JSON.parse(String(response).substring(7, String(response).length));
        if (result.success === false) {
          this.$notify({
            title: '错误',
            message: `${result.message}`,
            type: 'error'
          });
        }
        if (result.detail !== undefined) {
          this.importResultDialog = true;
          this.taskImportResult = result.detail;
        }
      } catch (e) {
        this.$notify({
          title: '错误',
          message: `未知错误，请联系管理员`,
          type: 'error'
        });
      }
    },
    submitUpload () {
      if (this.fileLength !== 0) {
        this.$refs.upload.submit();
      } else {
        this.$notify({
          title: '警告',
          message: '请先上传文件',
          type: 'warning'
        });
      }
    },
    resetFormData () {
      this.shipmentData.moNumber = '';
      this.shipmentData.remark = '';
      this.shipmentData.productModelId = 0;
      this.shipmentData.productId = 0;
      this.shipmentData.branchNum = 0;
      this.shipmentData.mainTheftPreventionNum = 0;
      this.shipmentData.isOver = 1;
      this.systemType = 1;
      this.systemSelected = [];
      try {
        this.$refs.upload.clearFiles();
      } catch (e) {}
    },
    productModelIdhandleChange (val) {
      this.shipmentData.productId = val[0];
      this.shipmentData.productModelId = val[1];
    },
    async reshipment () {
      let { data } = await http.post(`/v1/device-sns/reshipment`, {
        id: this.itemId,
        systemId: this.shipmentData.moNumber,
        remark: this.shipmentData.remark,
        productModelId: this.shipmentData.productModelId,
        productId: this.shipmentData.productId,
        branchNum: this.shipmentData.branchNum,
        mainTheftPreventionNum: this.shipmentData.mainTheftPreventionNum,
        isOver: this.shipmentData.isOver
      });
      if (data.code === 200) {
        this.$notify({
          title: '成功',
          message: '操作成功',
          type: 'success'
        });
        if (data.detail !== undefined) {
          this.importResultDialog = true;
          this.taskImportResult = data.detail;
        }
      } else {
        this.$notify({
          title: '错误',
          message: `操作失败`,
          type: 'error'
        });
      }
      this.resetFormData();
      this.getMaterialList();
      this.reshipmentDialog = false;
    }
  },
  created () {
    this.getMaterialList();
    this.getProductModel();
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/shipment/materialList.vue